export const Ai = (flujax) => ({
  async chatPrompt (promptWithHistory) {
    return flujax.post('/ai/chat/prompt', promptWithHistory)
  },

  async interject (interjection) {
    return flujax.post('/ai/chat/prompt/interject', interjection)
  },

  async chatPromptPlanType (planType, item) {
    return flujax.post(`/ai/chat/${planType}`, item)
  },

  async balance () {
    return flujax.post('ai/chat/balance')
  },

  async slash () {
    return flujax.post('ai/chat/slash')
  },

  async htmlTemplate (templateRequest) {
    return flujax.post('ai/chat/html/template', templateRequest)
  },

  async promptFeedback (prompt) {
    return flujax.post('ai/chat/prompt/feedback', prompt)
  },

  async htmlResize (payload) {
    return flujax.post('ai/chat/creative/html/resize', payload)
  },

  async htmlAdjust (payload) {
    return flujax.post('ai/chat/creative/html/adjust', payload)
  },

  async session () {
    return flujax.get('ai/chat/session')
  },

  async getSession (sessionId) {
    return flujax.get(`ai/chat/session/${sessionId}`)
  },

  async getProposal (accountPlanId) {
    return flujax.get(`ai-proposal/get?accountPlanId=${accountPlanId}`)
  },

  async updateProposal (aiProposalId, proposalData) {
    return flujax.post(`ai-proposal/update?aiProposalId=${aiProposalId}`, proposalData)
  },

  async regenerateProposal (existingProposal, userPrompt) {
    return flujax.post('ai-proposal/regenerate', {
      proposal: existingProposal,
      userPrompt: userPrompt
    })
  },

  async regenerateProposalAsync (existingProposal, userPrompt) {
    return flujax.post('ai-proposal/regenerate/async', {
      proposal: existingProposal,
      userPrompt: userPrompt
    })
  },

  // Account Insights endpoints
  async getAccountInsights (accountPlanId) {
    return flujax.get(`account-insights/get?accountPlanId=${accountPlanId}`)
  },

  async getAccountInsightsById (accountInsightsId) {
    return flujax.get(`account-insights/get?accountInsightsId=${accountInsightsId}`)
  },

  async generateAccountInsights (accountPlanId, options = {}) {
    return flujax.post('account-insights/generate', {
      accountPlanId,
      timeframe: options.timeframe || 'MONTHLY',
      startDate: options.startDate,
      endDate: options.endDate
    })
  },

  async removeSession (sessionId) {
    return flujax.get(`ai/chat/session/remove/${sessionId}`)
  },

  async getUserInputQuestions (museSessionId) {
    return flujax.get(`ai/chat/user-input/${museSessionId}`)
  },

  async submitUserInput (museSessionId, userInput) {
    return flujax.post(`ai/chat/user-input/${museSessionId}/submit`, { response: userInput })
  },

  async executeInstruction (executionRequest) {
    return flujax.post('ai/instruction/async/execute', executionRequest)
  },

  async getInstructionAdapters () {
    return flujax.get('ai/instruction/fluency_supplied/get')
  }
})
